export default "__VITE_ASSET__4d785230__"